import React from "react";

export default function renderIcon({
  width = 34,
  height = 34,
  color = "#f5aa1b",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <defs>
        <clipPath id="clip-path">
          <rect width="34" height="34" fill="none" />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect
            id="Rectangle_2043"
            data-name="Rectangle 2043"
            width="31.521"
            height="31.359"
            transform="translate(0 0)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_979" data-name="Group 979" transform="translate(-28 -584)">
        <g
          id="Repeat_Grid_1"
          data-name="Repeat Grid 1"
          transform="translate(28 584)"
          clip-path="url(#clip-path)"
        >
          <g
            id="Group_978"
            data-name="Group 978"
            transform="translate(-28 -574)"
          >
            <circle
              id="Ellipse_3786"
              data-name="Ellipse 3786"
              cx="17"
              cy="17"
              r="17"
              transform="translate(28 574)"
              fill="#f5aa1b"
            />
          </g>
        </g>
        <g
          id="Group_959"
          data-name="Group 959"
          transform="translate(57.24 538.321)"
        >
          <g
            id="Group_497"
            data-name="Group 497"
            transform="translate(-28 47)"
            clip-path="url(#clip-path-2)"
          >
            <path
              id="Path_4423"
              data-name="Path 4423"
              d="M33.066,25.746H23.748a.473.473,0,1,1,0-.945h9.318a.473.473,0,1,1,0,.945"
              transform="translate(-12.647 -13.476)"
              fill="#fff"
            />
            <path
              id="Path_4424"
              data-name="Path 4424"
              d="M33.066,30.881H23.748a.473.473,0,0,1,0-.945h9.318a.473.473,0,0,1,0,.945"
              transform="translate(-12.647 -16.266)"
              fill="#fff"
            />
            <path
              id="Path_4425"
              data-name="Path 4425"
              d="M28.108,41.412h-4.36a.473.473,0,1,1,0-.945h4.36a.473.473,0,1,1,0,.945"
              transform="translate(-12.647 -21.988)"
              fill="#fff"
            />
            <path
              id="Path_4426"
              data-name="Path 4426"
              d="M28.108,46.547h-4.36a.473.473,0,1,1,0-.945h4.36a.473.473,0,1,1,0,.945"
              transform="translate(-12.647 -24.778)"
              fill="#fff"
            />
            <path
              id="Path_4427"
              data-name="Path 4427"
              d="M31.858,12.883V31.2l-1.065-.605-1.491.833L27.758,30.6l-1.491.8-1.5-.8-1.477.845-1.5-.845-1.464.845-1.584-.833-1.025.605V12.883Zm0-.945H17.708a1.033,1.033,0,0,0-1.1.945V31.22a.938.938,0,0,0,.59.837,1.25,1.25,0,0,0,.513.108A1.233,1.233,0,0,0,18.333,32l.435-.257.973.512a1.26,1.26,0,0,0,1.192-.021l.857-.495.892.5a1.259,1.259,0,0,0,1.216,0l.888-.508.9.479a1.261,1.261,0,0,0,1.164,0l.909-.487.961.511a1.261,1.261,0,0,0,1.183-.011l.884-.494.461.262a1.258,1.258,0,0,0,1.13.045.936.936,0,0,0,.581-.832V12.883a1.033,1.033,0,0,0-1.1-.945"
              transform="translate(-9.023 -6.487)"
              fill="#fff"
            />
            <path
              id="Path_4428"
              data-name="Path 4428"
              d="M33.066,21.046H23.748a.473.473,0,0,1,0-.945h9.318a.473.473,0,0,1,0,.945"
              transform="translate(-12.647 -10.922)"
              fill="#fff"
            />
            <path
              id="Path_4429"
              data-name="Path 4429"
              d="M41.8,38.852c0-.692-.461-.954-1.051-1.078l-.558-.118c-.424-.091-.622-.284-.622-.654,0-.386.322-.616.789-.616a.813.813,0,0,1,.911.788l.51-.107A1.164,1.164,0,0,0,40.639,36V34.813a.268.268,0,1,0-.536,0V36a1.071,1.071,0,0,0-1.057,1.05A1.022,1.022,0,0,0,40,38.1l.552.113c.445.091.724.236.724.686,0,.483-.434.654-.848.654a.956.956,0,0,1-1.029-.88l-.515.075a1.286,1.286,0,0,0,1.217,1.2v1.2a.268.268,0,0,0,.536,0V39.961A1.132,1.132,0,0,0,41.8,38.852"
              transform="translate(-21.128 -18.77)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
